import { Link } from "react-router-dom";

const FOOTER_LINKS = [
  { to: "/pricing", label: "Pricing" },
  { to: "/roadmap", label: "Roadmap" },
  { to: "/help", label: "Docs" },
  { to: "/security", label: "Security" },
  { to: "/privacy", label: "Privacy" },
  { to: "/terms", label: "Terms" },
];

/**
 * Shared site footer used on every page — marketing, legal, help, and the app
 * shell — so navigation out of the product is never a dead end. The
 * "DeployCompare" wordmark links to the public home (/), distinct from the app
 * header's logo which targets /app.
 */
export function SiteFooter({ reloadDocument = false }: { reloadDocument?: boolean }) {
  return (
    <footer className="mt-auto border-t border-border">
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-2 px-4 py-3 text-xs text-muted-foreground sm:px-6">
        <Link
          to="/"
          reloadDocument={reloadDocument}
          className="inline-flex min-h-11 items-center px-2 font-bold tracking-tight hover:text-foreground"
        >
          DeployCompare
        </Link>
        <nav className="flex flex-wrap items-center">
          {FOOTER_LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              reloadDocument={reloadDocument}
              className="inline-flex min-h-11 items-center px-2 hover:text-foreground"
            >
              {link.label}
            </Link>
          ))}
          {/* Route to a human — plain anchor, not a router Link (mail client, not a route). */}
          <a
            href="mailto:support@deploycompare.com"
            className="inline-flex min-h-11 items-center px-2 hover:text-foreground"
          >
            Support
          </a>
        </nav>
      </div>
    </footer>
  );
}
